
































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import useAuthUser from "@/hooks/useAuthUser";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import SendMessageController from "@/components/SendMessageController/SendMessageController.vue";
import UserBadgeWithAvatar from "@/components/UserBadgeWithAvatar/UserBadgeWithAvatar.vue";
import { appointmentTypeNames } from "@/views/PageAppointments/config";

export default defineComponent({
  name: "",
  components: {
    BaseConfirm,
    UserBadgeWithAvatar,
    BaseButton,
    SendMessageController,
    BaseInputTextarea,
  },
  props: {
    show: { type: Boolean, required: true },
    appointment: { type: Object as () => Appointment | null, default: null },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();
    const messageValue = ref("");
    const processing = ref(false);
    const opponent = computed(() => {
      if (!props.appointment) return;
      return authUserStrict.value.id === props.appointment.consumerId
        ? props.appointment.provider
        : props.appointment.consumer;
    });

    const onSubmit = (cb: (text: string) => Promise<any>) => {
      processing.value = true;
      emit(
        "confirm",
        props.appointment?.id,
        () => cb(messageValue.value),
        () => (processing.value = false)
      );
    };

    return {
      appointmentTypeNames,
      opponent,
      messageValue,
      processing,
      onSubmit,
    };
  },
});
